import { useLazyApiGatewayQuery } from '~hooks';
import { GET_DYNAMIC_PRICES } from '~queries';
import { Query, QueryDynamicPricesArgs } from '~types/appsync.types';

const useDynamicPrices = () => {
  const [executeDynamicPrices, state] = useLazyApiGatewayQuery<Query, QueryDynamicPricesArgs>(
    GET_DYNAMIC_PRICES,
  );
  return [executeDynamicPrices, state] as const;
};

export default useDynamicPrices;
